"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = logTiming;
const getTiming_1 = __importDefault(require("./getTiming"));
function logTiming({ tuneInApiClient }) {
    const metrics = (0, getTiming_1.default)();
    if (metrics) {
        tuneInApiClient.logging.infoLog({
            message: 'timing',
            context: {
                metrics,
                pagePath: window.location.pathname,
            },
        });
    }
}
